import { HttpClient } from '@angular/common/http';
import { animate, state, style, transition, trigger } from '@angular/animations';
import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { Observable } from 'rxjs';

const DEFAULT_LINK = 'default_link';

@Component({
  selector: 'app-mark-down',
  templateUrl: './mark-down.component.html',
  styleUrls: ['./mark-down.component.scss'],
})
export class MarkDownComponent implements OnInit {
  @Input() isOpen = false;
  storageUseIframe: string;
  urlIframe: any;
  showIframe = false;
  isClickBtn = false;
  constructor(
    public sanitizer: DomSanitizer,
    private http: HttpClient
  ) { }

  ngOnInit() {
    this.storageUseIframe = 'userIframe_' + localStorage.getItem('userName');
    if (this.getDomain()) {
      this.getLinkIframe();
      this.createLocalStorage();
    }
  }

  getLinkIframe() {
    this.http.get('/assets/files/link_iframe.json').subscribe(res => {
      const url = this.getDomain();
      if (res) {
        if (url in res) {
          this.urlIframe = this.sanitizer.bypassSecurityTrustResourceUrl(res[url]);
          this.isOpen = true;
        } else {
          this.urlIframe = this.sanitizer.bypassSecurityTrustResourceUrl(res[DEFAULT_LINK]);
          this.isOpen = true;
        }
      }
    });
  }

  onClickedInsideBtn() {
    this.isClickBtn = true;
  }

  onClickedOutside() {
    if (!this.isClickBtn) {
        this.showIframe = false;
    }
    this.isClickBtn = false;
  }

  clickShowIframe() {
    this.showIframe = !this.showIframe;
  }

  getDomain(): string {
    // debugger
    const url = window.location.href;
    if (url) {
      const arr = url.split('/');
      let result = '';
      for (let i = 3; i < arr.length; i++) {
        result = result + '/' + arr[i];
      }
      return result;
    } else { return null; }
  }

  createLocalStorage() {
    const url = this.getDomain();
    if (localStorage.getItem(this.storageUseIframe)) {
      const listUrlIframe = JSON.parse(localStorage.getItem(this.storageUseIframe));
      if (!listUrlIframe.includes(url)) {
        listUrlIframe.push(url);
        localStorage.setItem(this.storageUseIframe, JSON.stringify(listUrlIframe));
        // this.showIframe = true;
      }
    } else {
      const listUrlIframe = [];
      listUrlIframe.push(url);
      localStorage.setItem(this.storageUseIframe, JSON.stringify(listUrlIframe));
      this.showIframe = true;
    }
  }
}
